<template>
  <div class="posterBg mobile-poster" id="posterBg" :style="{ backgroundImage: `url(${nowbgimg})` }">
    <div class="posterInner">
      <div class="title" v-show="showTit">{{ title }}</div>
      <div class="bookImg">
        <div>
          <img :src="nowUrl" alt="" crossOrigin="anonymous" class="cover" />
          <img src="@imgs/bookcase.png" alt="" v-if="customWhere == 'album' || customWhere == 'lib'" class="bookcase" />
        </div>
      </div>
      <div class="codeFooter">
        <p v-show="showTip">{{ tipText }}</p>
        <Vue-qr
          :text="qrObj.value"
          :size="800"
          :margin="50"
          v-show="showCode"
          class="code"
          :style="{
            height: `${size}px`
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import api from '@api/bookshelfDetail'
import Interface from '@api/bookLib'
import apis from '@api/getBook'
import { isPureNum } from '@/utils'
export default {
  name: 'mobileposterCont',
  data() {
    return {
      showTit: true,
      showTip: true,
      showCode: true,
      title: '',
      nowUrl: '',
      nowbgimg: '',
      tipText: '微信识别二维码',
      customWhere: '',
      posterTitle: '',
      curPage: this.pageMessage,
      coverSize: []
    }
  },
  props: {
    qrObj: {
      type: Object,
      default: function() {
        return {}
      }
    },
    size: {
      default: 80
    },
    pageMessage: {}
  },
  watch: {
    pageMessage(val) {
      this.curPage = val
      this.judgeWhere()
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    currentPageNum() {
      return this.currentPage.split('/')[0]
    },
    curPageLeft() {
      let page
      if (this.currentPageNum.indexOf('-') > -1) {
        page = this.currentPageNum.split('-')[0]
      } else {
        page = this.currentPageNum
      }
      return page.trim()
    },
    currentUrl() {
      let timers = new Date().getTime()
      return this.bookPath + '/' + this.curPageLeft + '.jpg' + '?v=' + timers
    },
    shareTitle() {
      return this.$store.state.config.bookObj.shareTitle
    },
    cusbgimg() {
      return this.$store.state.config.poster.posterBg || require('@imgs/poster.png')
    },
    bookPath() {
      return this.$store.state.book.bookPath
    },
    currentPageArray() {
      return this.$store.state.book.currentPage
    },
    totalPage() {
      return this.$store.state.book.totalPage
    },
    currentPage() {
      let currentPageArray = this.$store.state.book.currentPage
      let page
      if (currentPageArray[0] === 0) {
        page = currentPageArray[1] + '/' + this.totalPage
      } else if (currentPageArray[1] === 0) {
        page = currentPageArray[0] + '/' + this.totalPage
      } else {
        page = currentPageArray.join(' - ') + '/' + this.totalPage
      }
      return page
    }
  },
  components: {
    VueQr
  },
  methods: {
    judgeWhere() {
      if ((this.qrObj.value && String(this.qrObj.value).indexOf('content') > -1) || String(this.qrObj.value).indexOf('book?') > -1) {
        const id = this.getId(this.qrObj.value)
        this.getEbookbyid(id)
        this.customWhere = 'book'
      } else if (String(this.qrObj.value).indexOf('paper?') > -1 || String(this.qrObj.value).indexOf('paperContent?') > -1) {
        const id = this.getId(this.qrObj.value)
        this.getPaperByid(id)
        this.customWhere = 'paper'
      } else if (this.qrObj.value && String(this.qrObj.value).indexOf('bookshelfdetail?id') > -1) {
        const id = this.getId(this.qrObj.value)
        this.getAlbumbyId(Number(id))
        this.customWhere = 'album'
      } else if (this.qrObj.value && String(this.qrObj.value).indexOf('bookLibdetail?id') > -1) {
        const id = this.getId(this.qrObj.value)
        this.getlibbyId(Number(id))
        this.customWhere = 'lib'
      }
    },
    getAlbumbyId(id) {
      const param = { id: id }
      const timers = new Date().getTime()
      api.bookshelfMobileDetail(param).then((res) => {
        if (res && res.data && res.data.code === 0) {
          if (res.data.data.posterStyle && res.data.data.poster) {
            this.title = res.data.data.posterName || res.data.data.name
            const posterCover = res.data.data.posterCover && res.data.data.posterCover.split(',')
            this.nowUrl = (posterCover[1] || (res.data.data.ebookList[0] && res.data.data.ebookList[0].coverUrl) || '') + '?v=' + timers
            if (res.data.data.posterPic != '' && res.data.data.posterPic != 'poster.png') {
              this.nowbgimg = res.data.data.posterPic + '?v=' + timers
            } else {
              this.nowbgimg = require('@imgs/poster.png')
            }
            this.posterTitle = res.data.data.posterTitle
            this.showTit = res.data.data.posterNameShow
            this.showTip = res.data.data.posterTextShow
            this.showCode = res.data.data.posterQrCodeShow
            this.tipText = res.data.data.posterPromptText
          } else {
            this.posterTitle = ''
            this.title = res.data.data.name
            // this.nowUrl = res.data.data.ebookList[0].coverUrl + '?v=' + timers
            this.nowUrl = res.data.data.ebookList[0] ? res.data.data.ebookList[0].coverUrl + '?v=' + timers : ''
            this.nowbgimg = require('@imgs/poster.png')
            this.showTit = true
            this.showTip = true
            this.showCode = true
            this.tipText = '微信识别二维码'
          }
          const arr = [this.showTit, this.showTip, this.showCode, this.tipText, this.posterTitle]
          this.$emit('getCoverOption', res.data.data.ebookList)
          this.$emit('getTitle', this.title)
          this.$emit('getSelData', arr)
        }
      })
    },
    getlibbyId(id) {
      const param = { id: id }
      const timers = new Date().getTime()
      Interface.getMobileBookLibInfo(param).then((res) => {
        if (res && res.data && res.data.code === 0) {
          if (res.data.data.posterStyle && res.data.data.poster) {
            this.title = res.data.data.posterName || res.data.data.name
            const posterCover = res.data.data.posterCover && res.data.data.posterCover.split(',')
            this.nowUrl = (posterCover[1] || (res.data.data.itemList[0] && res.data.data.itemList[0].coverUrl) || '') + '?v=' + timers
            if (res.data.data.posterPic != '' && res.data.data.posterPic != 'poster.png') {
              this.nowbgimg = res.data.data.posterPic + '?v=' + timers
            } else {
              this.nowbgimg = require('@imgs/poster.png')
            }
            this.showTit = res.data.data.posterNameShow
            this.showTip = res.data.data.posterTextShow
            this.showCode = res.data.data.posterQrCodeShow
            this.tipText = res.data.data.posterPromptText
            this.posterTitle = res.data.data.posterTitle
          } else {
            this.posterTitle = ''
            this.title = res.data.data.name
            // this.nowUrl = res.data.data.itemList[0].coverUrl + '?v=' + timers
            this.nowUrl = res.data.data.itemList[0] ? res.data.data.itemList[0].coverUrl + '?v=' + timers : ''
            this.nowbgimg = require('@imgs/poster.png')
            this.showTit = true
            this.showTip = true
            this.showCode = true
            this.tipText = '微信识别二维码'
          }
          const arr = [this.showTit, this.showTip, this.showCode, this.tipText, this.posterTitle]
          this.$emit('getCoverOption', res.data.data.itemList)
          this.$emit('getTitle', this.title)
          this.$emit('getSelData', arr)
        }
      })
    },
    getPaperByid(id) {
      const param = { id: id }
      const timers = new Date().getTime()
      apis.GetPaperDetails(param).then((res) => {
        if (res && res.data && res.data.status === 0) {
          let pMsn = this.curPage
          let pageMessage = pMsn && String(pMsn).indexOf('/') ? String(pMsn).split('/')[0] : pMsn
          if (res.data.data.posterStyle && res.data.data.poster) {
            this.title = res.data.data.posterName || res.data.data.title
            const posterCover = res.data.data.posterCover && res.data.data.posterCover.split(',')
            if (posterCover[0] == '1') {
              this.nowUrl = res.data.data.path + '/1.jpg' + '?v=' + timers
            } else if (posterCover[0] == '2') {
              this.nowUrl = res.data.data.path + '/' + pageMessage + '.jpg' + '?v=' + timers
            }
            if (res.data.data.posterPic != '' && res.data.data.posterPic != 'poster.png') {
              this.nowbgimg = res.data.data.posterPic
            } else {
              this.nowbgimg = require('@imgs/poster.png')
            }
            this.posterTitle = res.data.data.posterTitle
            this.showTit = res.data.data.posterNameShow
            this.showTip = res.data.data.posterTextShow
            this.showCode = res.data.data.posterQrCodeShow
            this.tipText = res.data.data.posterPromptText
          } else {
            this.posterTitle = ''
            this.title = res.data.data.title
            this.nowUrl = res.data.data.path + '/' + pageMessage + '.jpg' + '?v=' + timers
            this.nowbgimg = require('@imgs/poster.png')
            this.showTit = true
            this.showTip = true
            this.showCode = true
            this.tipText = '微信识别二维码'
          }
          const arr = [this.showTit, this.showTip, this.showCode, this.tipText, this.posterTitle]
          this.$emit('getCoverOption', 'book')
          this.$emit('getTitle', this.title)
          this.$emit('getSelData', arr)
        }
      })
    },
    getEbookbyid(id) {
      const param = { id: id }
      const timers = new Date().getTime()
      apis.GetMobileBookDetails(param).then((res) => {
        if (res && res.data && res.data.code === 0) {
          let pMsn = this.curPage
          let pageMessage = pMsn && String(pMsn).indexOf('/') ? String(pMsn).split('/')[0] : pMsn
          if (res.data.data.posterStyle && res.data.data.poster) {
            this.title = res.data.data.posterName || res.data.data.title
            const posterCover = res.data.data.posterCover && res.data.data.posterCover.split(',')
            if (posterCover[0] == '1') {
              this.nowUrl = res.data.data.path + '/1.jpg' + '?v=' + timers
            } else if (posterCover[0] == '2') {
              this.nowUrl = res.data.data.path + '/' + pageMessage + '.jpg' + '?v=' + timers
            }
            if (res.data.data.posterPic != '' && res.data.data.posterPic != 'poster.png') {
              this.nowbgimg = res.data.data.posterPic
            } else {
              this.nowbgimg = require('@imgs/poster.png')
            }
            this.posterTitle = res.data.data.posterTitle
            this.showTit = res.data.data.posterNameShow
            this.showTip = res.data.data.posterTextShow
            this.showCode = res.data.data.posterQrCodeShow
            this.tipText = res.data.data.posterPromptText
          } else {
            this.posterTitle = ''
            this.title = res.data.data.title
            this.nowUrl = res.data.data.path + '/' + pageMessage + '.jpg' + '?v=' + timers
            this.nowbgimg = require('@imgs/poster.png')
            this.showTit = true
            this.showTip = true
            this.showCode = true
            this.tipText = '微信识别二维码'
          }
          const arr = [this.showTit, this.showTip, this.showCode, this.tipText, this.posterTitle]
          this.$emit('getCoverOption', 'book')
          this.$emit('getTitle', this.title)
          this.$emit('getSelData', arr)
        }
      })
    },
    getId(url) {
      const a = url.indexOf('?id=')
      const b = url.indexOf('&')
      if (b == -1) {
        const id = isPureNum(url.slice(a + 4))
        return id
      } else {
        const id = isPureNum(url.slice(a + 4, b))
        return id
      }
    }
  },
  mounted() {
    this.judgeWhere()
  }
}
</script>

<style lang="scss" scoped>
.posterBg {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .posterInner {
    position: relative;
  }
  .title {
    color: #fff;
    position: absolute;
    top: 24px;
    width: 100%;
    text-align: center;
  }
  .codeFooter {
    color: #000;
    position: absolute;
    bottom: 35px;
    z-index: 4; // 确保海报二维码在最上面
    p {
      margin: 0;
      width: 142px;
      position: absolute;
      margin: 0;
      left: 2%;
      top: 50%;
      transform: translateY(-50%);
      max-height: 50px;
      line-height: 24px;
    }
    .code {
      position: absolute;
      right: 2%;
      top: 0;
    }
  }
}
.mobile-poster {
  position: fixed;
  z-index: -1;
  top: 200%;
  width: 100%;
  height: 600px;
  .posterInner {
    width: 89.3%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .title {
      width: 263px;
      max-height: 40px;
      line-height: 21px;
      font-size: 16px;
      font-weight: 500;
      color: #fff;
      text-align: center;
    }
    .bookImg {
      width: 100%;
      position: absolute;
      top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 360px;
      div {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin: 0 auto;
        .cover {
          max-width: 65%;
          z-index: 3;
          position: relative;
        }
        .bookcase {
          position: relative;
          z-index: 2;
          width: 100%;
          top: -12px;
        }
        .setWidth {
          max-width: 76.15%;
        }
        .setHeight {
          max-height: 360px;
        }
      }
    }
    .codeFooter {
      width: 76.15%;
      font-size: 14px;
      height: 80px;
      span {
        display: inline-block;
        height: 80px;
        line-height: 80px;
      }
    }
  }
}
</style>
